import React from "react";
import { FormField, type FormFieldProps } from "../FormField/FormField";

const CalendarIcon = () => (
  <svg
    width="14"
    height="14"
    viewBox="0 0 14 14"
    fill="none"
    stroke="var(--color-content-secondary)"
    strokeWidth="1.3"
    strokeLinecap="round"
    strokeLinejoin="round"
    aria-hidden="true"
  >
    <rect x="1.5" y="2.5" width="11" height="10" rx="1.5" />
    <path d="M1.5 5.5h11M4.5 1.5v2M9.5 1.5v2" />
  </svg>
);

export interface DateFieldProps extends Omit<FormFieldProps, "type" | "trailingIcon"> {}

export function DateField({ id, ...rest }: DateFieldProps) {
  const uidRef = React.useRef(`makula-date-${Math.random().toString(36).slice(2)}`);
  const inputId = id ?? uidRef.current;

  return (
    <>
      <style>{`
        #${CSS.escape(inputId)}[type="date"] { appearance: none; -webkit-appearance: none; }
        #${CSS.escape(inputId)}[type="date"]::-webkit-calendar-picker-indicator { display: none; -webkit-appearance: none; }
        #${CSS.escape(inputId)}[type="date"]::-webkit-inner-spin-button,
        #${CSS.escape(inputId)}[type="date"]::-webkit-outer-spin-button { display: none; }
        #${CSS.escape(inputId)}[type="date"]::-webkit-date-and-time-value { text-align: left; }
      `}</style>
      <FormField
        id={inputId}
        type="date"
        trailingIcon={<CalendarIcon />}
        {...rest}
      />
    </>
  );
}
